import React, { Component } from 'react';
import moment from 'moment';
import RecentActivity from 'components/modules/user/recent-activity';
import CargomaticCard from 'components/v2/card';
import LabelValue from 'components/ui/tailwind/label-value';
import SessionStore from 'stores/SessionStore';
import EditButton from 'components/v2/buttons/EditButton';
import Container from 'components/v2/container';
import { withTranslation } from 'react-i18next';
import { Avatar } from '../Avatar';
const canChangePassword = (account, agent) => {
    if (account._type !== 'Admin')
        return true;
    if (account._id === agent._id)
        return true;
    if (agent.roles.includes('admin'))
        return true;
    return false;
};
const hasEditPermission = (account, agent) => {
    if (agent.roles.includes('admin') || account._id === agent._id)
        return true;
    return false;
};
class AdminDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { user, t } = this.props;
        return (React.createElement(Container, { className: "min-w-full py-4" },
            React.createElement("div", { className: "grid grid-cols-12 gap-3" },
                React.createElement("div", { className: "col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-3 2xl:col-span-2" },
                    React.createElement(CargomaticCard, null,
                        React.createElement("div", { className: "bg-white rounded-xl flex items-center border-b border-solid border-grey-light pb-2" },
                            React.createElement("div", { className: "shrink-0" },
                                React.createElement(Avatar, { size: "medium", url: null })),
                            React.createElement("div", { className: "text-lg lg:text-xl font-medium text-black ml-2" },
                                ' ',
                                `${user.first_name} ${user.last_name}`)),
                        React.createElement("div", { className: "flex justify-between pt-2" },
                            React.createElement(LabelValue, { value: `${user.first_name} ${user.last_name}`, icon: "user" }),
                            hasEditPermission(user, SessionStore.getUser()) && (React.createElement(EditButton, { onClick: this.props.onEditProfileClick }))),
                        React.createElement(LabelValue, { value: user.email, icon: "envelope" }),
                        React.createElement(LabelValue, { value: user.phone, icon: "phone" }),
                        React.createElement(LabelValue, { value: `Last seen ${moment(user.last_seen).fromNow()} ago...`, icon: "question-sign" }),
                        React.createElement("div", { className: "mt-6 border-t border-solid border-grey-light" },
                            React.createElement("button", { disabled: !canChangePassword(user, SessionStore.getUser()), className: "w-full button button-hollow-red", onClick: this.props.onChangePasswordClick }, t('CHANGE_PASSWORD'))))),
                React.createElement("div", { className: "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-5 2xl:col-span-5" },
                    React.createElement(RecentActivity, { email: user.email })))));
    }
}
export default withTranslation()(AdminDetails);
